(function () {
  'use strict';

  angular.module('app').service('VersioningModalService', VersioningModalService);

  VersioningModalService.$inject = ['ModalService'];

  // export function VersioningModalService(ModalService) {
  function VersioningModalService(ModalService) {
    var service = {
      openUpdateUserAppVersionModal: openUpdateUserAppVersionModal,
    };

    return service;

    ////////////////////////////

    function openUpdateUserAppVersionModal(currentUserId) {
      ModalService.showModal({
        templateUrl: './app/ajs/admin/versioning/modals/update-user-app-version-modal.html',
        controller: AppVersionInfoModalCtrl,
        controllerAs: 'vm',
        inputs: {
          currentUserId: currentUserId,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      AppVersionInfoModalCtrl.$inject = [
        '$element',
        'currentUserId',
        'CONFIGURATIONS',
        'VersioningService',
        'userService',
      ];
    }

    // UserService
    function AppVersionInfoModalCtrl(
      $element,
      currentUserId,
      CONFIGURATIONS,
      VersioningService,

      // Angular downgraded service
      userService
    ) {
      var vm = this;

      vm.dateDisplay = CONFIGURATIONS.DATE_DISPLAY;

      vm.modalTitle = 'APP_VERSION';

      // Methods
      vm.updateUserAppVersion = updateUserAppVersion;

      // Initializers
      getCurrentAppVersion();

      function getCurrentAppVersion() {
        VersioningService.getCurrentAppVersion().then(function (data) {
          vm.currentAppVersion = data;
        });
      }

      function updateUserAppVersion() {
        vm.sendingForm = true;
        // UserService.updateUserAppVersion(currentUserId).then(function () {
        userService.updateUserAppVersion(currentUserId).subscribe(() => {
          $element.modal('hide');

          location.reload(); // true
        });
      }
    }
  }
})();
